import { render, staticRenderFns } from "./StackEffectViz.vue?vue&type=template&id=48ba8be3&scoped=true"
import script from "./StackEffectViz.vue?vue&type=script&lang=js"
export * from "./StackEffectViz.vue?vue&type=script&lang=js"
import style0 from "./StackEffectViz.vue?vue&type=style&index=0&id=48ba8be3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba8be3",
  null
  
)

export default component.exports